import MUIButton from "./../../Component/UI/MUIButton/MUIButton";
import classes from "./Header.module.css";

export default function Header({
  title,
  actionText,
  actionVariant = "btn",
  className,
  titleClassName,
  renderAction = () => {},
  
}) {
  return (
    <header
      className={`${classes.container} ${className}`}
      id="brandTitleSection"
    >
      <h4 className={`${classes.title} ${titleClassName}`}>{title}</h4>
      {actionText && actionVariant == "btn" ? (
        <div className={classes.action_button}>
          {/* <MUIButton
            data-html2canvas-ignore
            variant={actionBtnVariant}
            startIcon={actionIcon ? actionIcon : null}
            onClick={onActionClick}
            className={actionBtnClassName}
          >
            {actionText}
          </MUIButton> */}
          {/* <MUIButton
            data-html2canvas-ignore
            variant={actionBtnVariant}
            startIcon={actionIcon ? actionIcon : null}
            onClick={secondActionClick}
            className={actionBtnClassName}
          >
            {secondActionText}
          </MUIButton> */}
        </div>
      ) : actionVariant != "btn" ? (
        <span className={classes.action_txt}>{actionText}</span>
      ) : null}
      {renderAction && renderAction()}
    </header>
  );
}
